export class SupersubPaths {
    static findAMatch = '/superSub/findMatch'
    static mySupersubsRequests = '/superSub/mySupersubsRequests'
    static whatIsSuperSub = '/superSub/whatIsSuperSub'
    static whatIsSuperSubCaptain = 'capitaine'
    static whatIsSuperSubPlayer = 'joueur'
}
